import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    sideval: "schemehaikya"
};

export const SideChange = createSlice({
    name: 'change',
    initialState: initialState,
    reducers: {
        setchangetomydukan: (state, action) => {
            state.sideval = "mydukan";
        },
        setchangetoskh: (state, action) => {
            state.sideval = "schemehaikya";
        },
    },
});

export const { setchangetoskh, setchangetomydukan } = SideChange.actions;

export default SideChange.reducer;
